import { createFileRoute } from "@tanstack/react-router";
import { LedgerAccountsEntries } from "@/components/Ledger/Accounts/Entries";
import BackButton from "@/components/GoBack";

function RouteComponent() {
  return (
    <>
      <div>
        <BackButton />
      </div>
      <LedgerAccountsEntries />
    </>
  );
}

export const Route = createFileRoute("/_authenticated/ledger/accounts/$id/")({
  component: RouteComponent,
  staticData: { page: ["deals", "tax"] },
});
